"use client";

import * as React from "react";
import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Toggles the light/dark variant of the active color theme. */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => setMounted(true), []);

  const isDark = (theme ?? "").includes("dark");
  const toggle = () => {
    const base = (theme ?? "default-light").replace(/-(light|dark)$/, "");
    setTheme(`${base}-${isDark ? "light" : "dark"}`);
  };

  return (
    <Button variant="ghost" size="icon" onClick={toggle} className="text-muted-foreground" aria-label="Toggle theme">
      {mounted && isDark ? <Sun className="size-5" /> : <Moon className="size-5" />}
    </Button>
  );
}
